import axios, { AxiosAdapter } from 'axios';
import { useSelector } from 'react-redux';
import { RootState } from '../store/index';
import history from '../history'
import React from 'react';
import { UserState } from '../store/reducers/userReducer';
import * as  webix from '@xbs/webix-pro';
import "@xbs/webix-pro/webix.css";
import { setupCache } from 'axios-cache-adapter'
import rateLimit from 'axios-rate-limit';
// Create `axios-cache-adapter` instance
const cache = setupCache({
    maxAge: 1 * 500
})

window.webix = webix;

// Create `axios` instance passing the newly created `cache.adapter`

async function ChangeLocation(relocationpath: string) {

    async function setNewLoation(relocationpath: string) {
        try {
            history && history.push(relocationpath);
        } catch (e) {

        }
    }
    setNewLoation(relocationpath);
}

export class APIClient extends React.Component {
    cancelToken = axios.CancelToken.source();
    endpoint = `${process.env.REACT_APP_HH_APIENDPOINT}`;
    endpointDash = `${process.env.REACT_APP_HH_DASHENDPOINT}`;
    endpointApiCore = `${process.env.REACT_APP_HH_APICOREENDPOINT}`;
    
    api = axios.create();

    //  api = axios.create({
    //    baseURL: `${process.env.REACT_APP_HH_APIENDPOINT}`,
    //    headers: { 'Cache-Control': 'no-cache' },
    //    adapter: throttleAdapterEnhancer(cacheAdapterEnhancer(axios.defaults.adapter as AxiosAdapter, true))
    //});
    wait = true;

    constructor(props: any) {
        super(props);
        // eslint-disable-next-line react-hooks/rules-of-hooks
        //  const user = useSelector((state: RootState) => state.user);
        this.api.defaults.timeout = 600000;
        this.api.defaults.headers.common['Access-Control-Allow-Headers'] = '*';
        this.api.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
        this.endpoint = `${process.env.REACT_APP_HH_APIENDPOINT}`;
        this.endpointDash = `${process.env.REACT_APP_HH_DASHENDPOINT}`;
        this.endpointApiCore = `${process.env.REACT_APP_HH_APICOREENDPOINT}`;

        var Heyho_Token = localStorage.getItem("Heyho_Token");
        
        if (Heyho_Token) {
            this.api.defaults.headers.common['Authorization'] = `Bearer ${Heyho_Token}`;
        }


        // api.defaults.headers.common['PathRoute'] = window.location.pathname;

        //api.defaults.adapter = throttleAdapterEnhancer(cacheAdapterEnhancer(axios.defaults.adapter as AxiosAdapter, true));

        //this.api.interceptors.response.use((response) => response, (error) => {

        //    if (error)
        //        if (error.response)
        //            if (error.response.status && error.response.status == 401) {
        //                return Promise.reject(error);
        //            }
        //    if (error)
        //        if (error.response)
        //            if (error.response.status && error.response.status == 500) {
        //                throw error;
        //            }
        //    return Promise.reject(error);
        //});
    }
}

export default APIClient;